// import store from '@/store/index.js'
// import { requestModule.postRequest } from '@/assets/libs/requestModule'
import SaleController from '@/assets/controllers/SaleController'
import requestModule from '../libs/requestModule'

const doCardTokenPayment = async function (totalValue, cardToken, type = 'credit') {
  return requestModule.postRequest('payment/checkout', { value: totalValue?.toFixed(2), type, info: { identifier: cardToken } })
}

const doPixPayment = async function (totalValue, type = 'pix') {
  try {
    const response = await requestModule.postRequest('payment/checkout', { value: totalValue?.toFixed(2), type })
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao processar pagamento Pix'
    return {
      error: true,
      message
    }
  }
}

const doFinishSale = async function ({ nsu, nit, CDTIPORECE, cart, eventData, paymentType }) {
  try {
    const response = await requestModule.postRequest('payment/sale-finish', {
      ...SaleController.buildSaleData(nsu, nit, CDTIPORECE, cart, eventData, paymentType)
    })
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao finalizar a venda'
    return {
      error: true,
      message
    }
  }
}

const getPixPaymentStatus = async function (nit) {
  return requestModule.postRequest('payment/consult', { nit })
}

const getPaymentsType = async () => {
  return requestModule.postRequest('payment/list', {}, null, 'get')
}

const doGooglePayPayment = async function (totalValue, paymentData) {
  if (!paymentData) {
    throw new Error('paymentData inválido para Google Pay')
  }

  const token = paymentData.tokenizationData?.token
  const cardNetwork = paymentData.info?.cardNetwork

  if (!token || !cardNetwork) {
    throw new Error('Token ou cardNetwork ausentes no paymentData')
  }

  const identifier = 'GOOGLE_PAY'

  const data = {
    value: totalValue?.toFixed(2),
    type: 'wallet',
    info: {
      identifier
    },
    wallet: {
      token,
      cardNetwork,
      identifier
    }
  }

  return requestModule.postRequest('payment/checkout', data)
}

const sendEmailConfirmation = async function () {
  try {
    const response = await requestModule.postRequest('sale/sendQrCodeByEmail', {})
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao enviar e-mail de confirmação'
    return {
      error: true,
      message
    }
  }
}

const sendCouponByEmail = async function (saleSeq, appLogo) {
  try {
    const response = await requestModule.postRequest('sale/sendCouponByEmail', { saleSeq, appLogo })
    return response
  } catch (error) {
    const message = error?.response?.data?.message || 'Erro ao enviar cupom por e-mail'
    return {
      error: true,
      message
    }
  }
}

export {
  getPixPaymentStatus,
  doCardTokenPayment,
  doFinishSale,
  doPixPayment,
  getPaymentsType,
  doGooglePayPayment,
  sendEmailConfirmation,
  sendCouponByEmail
}
